// extracted by mini-css-extract-plugin
module.exports = {"cardBG":"panel-module--cardBG--2nYJe","imgBg":"panel-module--imgBg--3FTWi","columWrapper":"panel-module--columWrapper--1gdXq"};